<div *ngIf="translationModel" class="wrapper flex flex-row full-grow-no-shrink-no-basis "
     [attr.data-copilot]="isLeftFrameLoaded && isRightFrameLoaded ? 'viewer-documents-loaded' : 'viewer-documents-loading'">
  <particle-original-form class="flex flex-col"
                          [translationSupportiveLanguage]="translationSupportiveLanguage"
                          [formInfo$]="originalForm$"
                          [translationModel]="translationModel"
                          [progressStatus$]="progressStatus$"
                          (iframeLoadedEvent)="onFrameLoaded($event)"
  ></particle-original-form>
  <div id="magic-scroller-container" class="magic-scroller-container">
    <i id="caret-square-up" class="fas fa-caret-square-up" (click)="handleiconSquireUpEvent()"></i>
    <div class="dummy-scroll-container">
      <div id="dummy-scroll-container" class="dummy-scroll">
        <div id="dummy-scroll-container-range" class="range">
          <i class="fas fa-caret-up"></i>
          <i class="fas fa-caret-down"></i>
        </div>
      </div>
    </div>
    <i id="caret-square-down" class="fas fa-caret-square-down" (click)="handleiconSquireDownEvent()"></i>
  </div>
  <particle-translated-form class="flex flex-col"
                            [translationSupportiveLanguage]="translationSupportiveLanguage"
                            [formInfo$]="translatedForm$"
                            [translationModel]="translationModel"
                            [progressStatus$]="progressStatus$"
                            [actionChanges$]="actionChanges$"
                            (iframeLoadedEvent)="onFrameLoaded($event)"
  ></particle-translated-form>
</div>
